import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import {useLocation, withRouter} from "react-router-dom";

import Button from "@mui/material/Button";

import {LOCAL_STORAGE_KEYS, LOOK_INTRO_STEPS, LOOK_INTRO_STEPS_MOBILE} from "../../core/constants";
import {setLocalStorageItem} from "../lookFunctions";
import {ROUTES} from "../../../../routes";
import {
  setLookActiveCategory, setLookIntroHidden,
  setLookIntroStep, setLookOpened,
  setLookOverlayOpened,
  setLookPageOpened
} from "../../../../actions/lookFunctions";
import LookIntroBoxSteps from "./lookIntroBoxSteps";
import LookIntroBoxIcon from "./lookIntroBoxIcon";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {getCommonVisualizerType} from "../../../../config";
import {useShowRoomLayoutsButton} from "../../../../misc/helperHooks";
import {getRoomIdeasTranslate} from "../lookRoomIdeasButton";

const getStepTranslateId = (introStep, isMobile, showAnotherTextFor, showRoomLayoutsButton) => {
  if (introStep === (isMobile ? LOOK_INTRO_STEPS_MOBILE.layouts : LOOK_INTRO_STEPS.layoutsAndRooms) && !showRoomLayoutsButton) {
    if (isMobile) {
      return "look.intro.step2.mobile.revert."
    }
    return "look.intro.step2.ideasOnly."
  }
  if (!introStep) {
    return "look.intro.welcome."
  }
  if (showAnotherTextFor) {
   return "look.intro.step"+introStep+".mobile."
  }
  return "look.intro.step"+introStep+"."
}

const LookIntroBox = (props) => {

  const {introStep, setLookOverlayOpened, setLookPageOpened, history, hideOverlay, setLookIntroStep, setLookOpened,
    setLookActiveCategory, setLookIntroHidden, introHidden, isMobile, fabricatorData, activePreset, intl,
    visualizersLoadedLength} = props;

  const location = useLocation();
  const [urlBeforeIntro, setUrlBeforeIntro] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setLookIntroHidden(false);
    }, 500);
    if (location && location.pathname) {
      setUrlBeforeIntro(location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const skipIntroButtonClick = (analyticsLabel) => {
    Analytics.sendClickEvent(analyticsLabel);
    hideOverlay(() => {
      setLookOverlayOpened("");
      setLookIntroStep(LOOK_INTRO_STEPS.welcome);
      if (fabricatorData.isEncore && analyticsLabel === LOOK_JOURNEY_ANALYTIC_EVENTS.lookIntroFinalStepStartDesign) {
        // last step start design click
        setLookPageOpened(ROUTES.rooms);
        history.push(ROUTES.rooms);
      }
    });
    setLocalStorageItem(LOCAL_STORAGE_KEYS.introVisited, true);
    if (urlBeforeIntro && (urlBeforeIntro !== "/")) {
      history.push(urlBeforeIntro);
    }
  }

  const goToIntroButtonClick = () => {
    setLookIntroStep(introStep + 1);
    setLookActiveCategory("");
    setLookOpened(null);
    setLookPageOpened("");
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookIntroLearnToUse);
    if (location && location.pathname !== ROUTES.home) {
      history.push(ROUTES.home);
    }
  }

  const showAnotherTextFor = isMobile && [LOOK_INTRO_STEPS.layoutsAndRooms, LOOK_INTRO_STEPS.review].includes(introStep);

  const showRoomLayoutsButton = useShowRoomLayoutsButton(activePreset, isMobile, visualizersLoadedLength);
  const stepTranslateId = getStepTranslateId(introStep, isMobile, showAnotherTextFor, showRoomLayoutsButton);

  const roomIdeasTranslate = getRoomIdeasTranslate(intl, fabricatorData);

  return (
    <div className={"look-intro__box look-intro__box--" + introStep + (introHidden ? " look-intro__box--hidden" : "")}>
      <div className="grohe-lead__box-icon">
        <LookIntroBoxIcon showRoomLayoutsButton={showRoomLayoutsButton}/>
      </div>
      <h2 className="look-intro__box-title">
        {fabricatorData.isNhance && (introStep === (isMobile ? LOOK_INTRO_STEPS_MOBILE.rooms : LOOK_INTRO_STEPS.layoutsAndRooms)) && !showRoomLayoutsButton
          ? roomIdeasTranslate
          : <FormattedMessage id={stepTranslateId + "title"}/>}
      </h2>
      <p className="look-intro__box-text">
        <FormattedMessage id={stepTranslateId + "text"} values={{
          visualizerType: getCommonVisualizerType(),
          roomIdeasButtonTranslate: isMobile && (introStep === LOOK_INTRO_STEPS_MOBILE.rooms)
            ? roomIdeasTranslate
            : roomIdeasTranslate.toLowerCase()
        }}/>
      </p>
      {introStep ? <LookIntroBoxSteps closeIntro={skipIntroButtonClick}/> : (
        <div className="look-intro__box-buttons">
          <Button className={"look-button look-button--160 look-button--no-transform look-button--no-padding "
            + (fabricatorData.isAmericanStandard ? "look-button--primary2" : "look-button--blue")}
                  onClick={goToIntroButtonClick}>
            <FormattedMessage id="look.intro.welcome.buttonLearn"/>
          </Button>
          <span className="look-intro__link" onClick={() => skipIntroButtonClick(LOOK_JOURNEY_ANALYTIC_EVENTS.lookIntroStartDesign)}>
            <FormattedMessage id="look.intro.welcome.buttonSkip"/>
          </span>
        </div>
      )}
    </div>
  )
};

LookIntroBox.propTypes = {
  hideOverlay: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {introStep, introHidden} = store.lookState;
  const {isMobile, visualizersLoaded} = store.serverState;
  const fabricatorData = store.fabricatorState;
  const {activePreset} = store.bathroomVisualizerState;

  return {
    introStep,
    introHidden,
    isMobile,
    fabricatorData,
    activePreset,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookPageOpened,
  setLookIntroStep,
  setLookActiveCategory,
  setLookOpened,
  setLookIntroHidden,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(LookIntroBox)
  )
)
